import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import LoadingPage from '../../components/LoadingPage';
import { db } from '../../../config/Fire';
import * as Constants from '../../../constants';
import { getUser } from '../../../reducers';
import Chats from '../../components/Chats';
import './styles.css';

const ChatClient = props => {
    const[actualProcedures, setActualProcedures] = useState(null)

    const setListenerForActualProcedures = user => {
        console.log("setListenerForActualProcedures client")
        db.ref(`${Constants.MAIN_NODES.PROCEDURES}`).orderByChild("userId").equalTo(`${user.id}`).on("value", function(snapListener) {
            if(snapListener.exists()) {
                const proceduresMap = {}
                snapListener.forEach(procedureSnap => {
                    const procedure = procedureSnap.val();
                    proceduresMap[procedure.id] = procedure;
                });
                setActualProcedures(proceduresMap)
            } else {
                setActualProcedures({})
            }
        })
        return <LoadingPage />
    }

    return (
        <div className="chatClientCont">
            {
                props.user ?
                    actualProcedures !== null ?
                        <Chats procedures={actualProcedures} enableChat={true} />
                        :
                        setListenerForActualProcedures(props.user)
                    :
                    <LoadingPage />
            }
        </div>
    );
};

ChatClient.propTypes = {
    
};

const mapDispatchToPropsActions = dispatch => ({
    
});

const mapStateToProps = state => ({ 
    user:  getUser(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ChatClient));